import { bool, func } from 'prop-types';
import React from 'react';

import { getTooltipButtonWithText } from '../../../../generic/Tooltip';
import { COLORS } from '../../../../utils/constants';
import HELP_TEXTS from '../../../help-texts';

const TooltipButtonComponent = getTooltipButtonWithText(HELP_TEXTS);

function ApproveTooltipButton({ disabled, onClick, ...rest }) {
  return (
    <TooltipButtonComponent
      helpKey="approve"
      section="statusChanges"
      resource="inv"
      disabled={disabled}
      showTooltip={disabled}
      onClick={onClick}
      {...rest}
      color={COLORS.SUCCESS}
    >
      Approve
    </TooltipButtonComponent>
  );
}

ApproveTooltipButton.propTypes = {
  disabled: bool.isRequired,
  onClick: func.isRequired,
};

export default ApproveTooltipButton;
